import { Fragment, useContext, useEffect, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import SubNavigation from "../../components/Header/SubNavigation";
import UserContext from "../../store/user-context";
import Footer from "../../components/Footer";
import NotificationVerificationF24Table from "../../components/Tables/NotificationVerificationF24Table";

import { Section, Spinner } from "design-react-kit";

const NotificationVerificationf24 = () => {
  const [error, setError] = useState(null);
  const [invalidNotifications, setInvalidNotifications] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      getInvalidNotificationsPaymentData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientName, userContext.selectedClientFiscalCode]);

  const getInvalidNotificationsPaymentData = () => {
    setIsLoading(true);
    sendApiRequest(
      "NotificationPaymentData/GetInvalidNotificationsPaymentData",
      "GET",
      true,
      { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
      signIn,
      signOut,
      navigate,
      createQueryString,
      userContext
    ).then((response) => {
      if (response !== undefined && response.errors !== null) {
        setError(response.errors);
        setIsLoading(false);
      } else {
        setInvalidNotifications(response.data.invalidNotifications);
        setIsLoading(false);
      }
    });
  };

  return (
    <Fragment>
      <SubNavigation display={false} />
      <Section>
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && invalidNotifications !== null && (
          <NotificationVerificationF24Table
            items={invalidNotifications}
            columns={[
              {
                name: "Data di acquisizione",
                type: "date",
                sortable: true,
                value: "creationDate",
              },
              {
                name: "Notifica",
                type: "string",
                sortable: true,
                value: "description",
              },
              {
                name: "Tipologia",
                type: "string",
                sortable: false,
                value: "clientCodeName",
              },
              {
                name: "",
                type: null,
                sortable: false,
                value: "",
              },
            ]}
            getInvalidNotificationsPaymentData={
              getInvalidNotificationsPaymentData
            }
          />
        )}
      </Section>
      <Footer />
    </Fragment>
  );
};

export default NotificationVerificationf24;
